import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';

const TenantError: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="d-error-page tenant-error">
      <i className="ri-error-warning-line ri-48px text-warning"></i>
      <h2>{t('common.errorMessages.tenantValidationPage.title')}</h2>
      <p>{t('common.errorMessages.tenantValidationPage.message')}</p>
    </div>
  );
};

export default TenantError;
